import React from 'react';

import {
  Flex, HStack, Stack,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { Controller } from 'react-hook-form';

import { Divider, Input } from 'components';
import { Datepicker } from 'components/Datepicker';
import { maskKm, maskTime } from 'utils/masks';

import BatchesForm from './Batch';
import DriverForm from './Driver';

export default function DeliveryForm({
  control, register, getValues, setValue, watch,
}:any) {
  return (
    <Flex flexDir="column">
      <Stack spacing={4}>
        <DriverForm
          control={control}
          getValues={getValues}
          setValue={setValue}
          watch={watch}
          drivers={{
            name: 'drivers',
            label: 'Condutores',
          }}
          vehicle={{
            name: 'vehicle',
            label: 'Veículo',
          }}
        />
        <HStack
          justify="space-between">
          <Controller
            name="dueAt"
            control={control}
            rules={{
              onChange(event) {
                if (event.target.value.length >= 10) {
                  const format = event.target.value.length === 10 ? 'DD/MM/YYYY' : undefined;
                  const date = dayjs(event.target.value, format);
                  if (date.isValid()) {
                    setValue('dueAt', date);
                  }
                }
              },
            }}
            render={({ field }) => (
              <Datepicker
                label="Data de Entrega"
                placeholder="00/00/0000"
                {...field}
              />
            )}
          />
          <Input
            {...register('dueTime')}
            label="Horário de Entrega"
            placeholder="00:00"
            onChange={({ target: { value } }) => {
              setValue('dueTime',
                maskTime.resolve(value),
              );
            }}
          />
        </HStack>
        <HStack justify="space-between">
          <Input
            label="KM Previsto"
            {...register('estimatedKm')}
            placeholder="000 Km"
            onChange={({ target: { value } }) => {
              setValue('estimatedKm',
                maskKm.resolve(value),
              );
            }}
          />
          <Input
            label="Volume previsto"
            {...register('estimatedVolume')}
            placeholder="Volume previsto de recebimento de material."
          />
        </HStack>
      </Stack>
      <Divider mb={8} />
      <BatchesForm
        name="collectActivities"
        control={control}
        watch={watch}
        setValue={setValue}
      />
    </Flex>
  );
}
